<template>
  <div class="pt-10">
    <div class="mx-auto px-6 lg:px-8 pt-16 pb-10">
      <div class="mx-auto max-w-6xl">
        <text-h2 class="text-center text-2xl mt-10">Frequently asked questions</text-h2>
        <dl class="mt-10 space-y-5 p-3">
          <Disclosure
            v-for="(faq, index) in faqs"
            :key="index"
            v-slot="{ open }"
            as="div"
            class="py-4 bg-gray-100"
          >
            <dt class="">
              <DisclosureButton
                class="flex w-full items-start justify-between text-left text-gray-900"
              >
                <span class="text-base font-semibold leading-7 px-3">{{
                  faq.question
                }}</span>
                <span class="ml-6 flex h-7 items-center pr-5">
                  <ChevronDownIcon
                    v-if="!open"
                    class="h-6 w-6"
                    aria-hidden="true"
                  />
                  <ChevronRightIcon v-else class="h-6 w-6" aria-hidden="true" />
                </span>
              </DisclosureButton>
            </dt>
            <DisclosurePanel as="dd" class="mt-2 pr-12">
              <p class="text-base leading-7 text-gray-600 px-3">
                {{ faq.answer }}
              </p>
            </DisclosurePanel>
          </Disclosure>
        </dl>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/vue/24/outline";

const faqs = [
  { 
    question: "What should I expect during my first appointment?",
    answer:
      "You will begin with an initial session with your psychiatrist. In this meeting, they will review your background, medical history, current symptoms, medications, and overall mental health goals. Every psychiatrist has their own style, but the purpose of this first session is to understand your individual needs, assess your mental health, provide any necessary diagnoses, develop a treatment plan, and prescribe medications if appropriate.",
  },
  {
    question: "Am I able to reschedule my appointment if my plans change?",
    answer:
      "If you miss your appointment or don't give us at least 24 hours advanced notice when you can't keep your appointment: You will be subject to a $30 no show fee ($100.00 for Dr. Berliner Manhattan patients) for established patient office visits or a $50.00 no show fee for EMG/NCV testing. The rescheduling of your next appointment will be at your treating physician's discretion as to times and dates. In other words, you can't simply schedule another appointment as you may have been able to do so in the past. Our practice strives to accommodate our patients schedules. Giving us advance notice allows us to treat all of our patients in a timely and effective manner.",
  },
  {
    question: "How long will my appointment take?",
    answer:
      "The length of your appointment will depend on several factors. Please arrive 15 minutes prior to your appointment time.",
  },
  {
    question: "How do I get my patient paperwork?",
    answer:
      "Prior to your appointment, you will receive an email/text message link from us to complete your new patient paperwork. If you do not receive this link, you may call our office to request one or simply arrive 45 minutes before your appointment to complete the questionnaire in our office. Please note, you may be required to complete additional paperwork in the office prior to your first appointment.",
  },
];
</script>
